import Duck from 'extensible-duck';

export default new Duck({
  namespace: 'GEWEB',
  store: 'SCRIBE-SAVEDPOI',
  types: [
    'SAVED_POI_BOOKMARK',
    'START_EDITING_SAVED_POI',
    'EDIT_SAVED_POI_FIELD',
    'CANCEL_EDITING_SAVED_POI',
    'SAVE_POI',
    'DELETE_SAVED_POI',
  ],
  reducer: (state, action, duck) => state,
  creators: duck => ({
    savePOIBookmark: (state, isSavedPOI, delivery, isPickUp) => ({
      type: duck.types.SAVED_POI_BOOKMARK,
      state,
      isSavedPOI,
      delivery,
      isPickUp,
    }),
    startEditingSavedPOI: () => ({
      type: duck.types.START_EDITING_SAVED_POI,
    }),
    cancelEditingSavedPOI: () => ({
      type: duck.types.CANCEL_EDITING_SAVED_POI,
    }),
    editSavedPOIField: (fieldName, fieldValue) => ({
      type: duck.types.EDIT_SAVED_POI_FIELD,
      fieldName, fieldValue
    }),
    savePOI: () => ({
      type: duck.types.SAVE_POI,
    }),
   deleteSavedPOI: () => ({
      type: duck.types.DELETE_SAVED_POI,
    }),
  }),
});
